import React from "react";

//UI COMPONENTS

import BottomBar from "./bottom-bar/BottomBar.tsx";
import LoadingScreen from "./LoadingScreen";
import RightSidePanel from "./RightSidePanel";
import Experience from "./Experience/Experience";
import NewTourPage from "../NewTourPage/NewTourPage";

//QUERY

import LeftSidePanel from "./LeftSidePanel";

/* eslint import/no-webpack-loader-syntax: off */

// @ts-expect-error
import buttonsCss from "!raw-loader!../common/buttons.css";

// @ts-expect-error
import formsCss from "!raw-loader!./RightSidePanel/forms.css";

//API

import {
  UseAssetsQuery,
  UseGetTour,
  useLocalizationFile,
} from "../../api/calls/Queries.ts";
import { useGetQuiz } from "../../api/calls/Quiz.ts";

//

import ErrorScreen from "./ErrorScreen.tsx";
import AssetList from "./AssetList/AssetList.tsx";
import MapEditor from "./MapEditor/MapEditor.tsx";
import WidePopup from "./WidePopup/WidePopup.tsx";

import { useTourDataStore, useWidePopupStore } from "../../api/Zustand.ts";
import { OPENAIENABLED } from "../../App.tsx";

function TourEditPage(props: { tourID: number }) {
  const { tourID } = props;

  const { data: TourData, isLoading, isError, error } = UseGetTour(tourID);

  const { setTourData } = useTourDataStore();

  React.useEffect(() => {
    if (TourData) setTourData(TourData);
  }, [TourData, setTourData]);

  const { data: quizData } = useGetQuiz(tourID, TourData?.assignedQuizID);

  const { data: images } = UseAssetsQuery(tourID, 2);

  const { data: languagefile } = useLocalizationFile();

  const widePopup = useWidePopupStore();

  const {
    isLoading: isLoadingPanos,
    isError: isPanosError,
    error: panosError,
  } = UseAssetsQuery(tourID, 1);

  return (
    <>
      <style>
        {buttonsCss}
        {formsCss}
      </style>

      {isLoading || isLoadingPanos ? (
        <LoadingScreen />
      ) : isError || isPanosError ? (
        <ErrorScreen error={error || panosError} />
      ) : TourData === null || TourData?.scenes === undefined ? (
        <NewTourPage tourID={tourID} />
      ) : (
        <>
          <MapEditor tourID={tourID} />
          <AssetList />
          {OPENAIENABLED && widePopup.isOpen && <WidePopup tourID={tourID} />}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                padding: "5px",
                boxSizing: "border-box",
                display: "flex",
                gap: "5px",
                height: "84%",
              }}
            >
              <LeftSidePanel />
              <Experience />
              <RightSidePanel />
            </div>
            <div
              style={{
                width: "100%",
                height: "16%",
              }}
            >
              <BottomBar />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default TourEditPage;
